import { useState } from 'react';
import { ORIGIN_TABLE_MAP } from 'features/daily-plan/constants';
import { useFeatureFlags } from 'providers/FeatureFlagsProvider';
import { SelectionType } from 'UI/constants/defaults';
import { Endpoints } from 'UI/constants/endpoints';
import { ContactEntityMapping, ENTITY_TYPE_ID_MAP } from 'UI/constants/entityTypes';
import { FeatureFlags } from 'UI/constants/featureFlags';

const getEntityTypePerItem = ({ table, item }) => {
  const itemName = item.type?.toLowerCase();
  const OBJECT_TO_EXTRACT_BY_ENTITY_TABLE = {
    [ORIGIN_TABLE_MAP.Candidates]: ENTITY_TYPE_ID_MAP[itemName],
    [ORIGIN_TABLE_MAP.Contacts]: ENTITY_TYPE_ID_MAP[ContactEntityMapping[item.type_id]],
    [ORIGIN_TABLE_MAP.Companies]: ENTITY_TYPE_ID_MAP[itemName],
    [ORIGIN_TABLE_MAP.ResumeSearch]: ENTITY_TYPE_ID_MAP[itemName]
  };

  return OBJECT_TO_EXTRACT_BY_ENTITY_TABLE[table];
};

// TODO: Adjust endpoints when the backend team adds support for multiple activity creation
const ENDPOINT_TO_ENTITY_TYPE_MAP = {
  [ORIGIN_TABLE_MAP.Candidates]: `${Endpoints.Candidates}/${Endpoints.Activities}`,
  [ORIGIN_TABLE_MAP.Contacts]: `${Endpoints.Names}/${Endpoints.Activities}`,
  [ORIGIN_TABLE_MAP.Companies]: `${Endpoints.Companies}/${Endpoints.Activities}`,
  [ORIGIN_TABLE_MAP.ResumeSearch]: `${Endpoints.Candidates}/${Endpoints.Activities}`
};

export const useActivityDrawerManager = ({
  selectedItems = [],
  selectionType = 'include',
  table
}) => {
  const { checkIfFeatureFlagEnabled } = useFeatureFlags();
  const canCreateMultipleActivities =
    checkIfFeatureFlagEnabled(FeatureFlags.MultipleActivitiesFromList) &&
    selectionType === SelectionType.Include;
  const [isActivityDrawerOpen, setIsActivityDrawerOpen] = useState(false);
  const handleOpenActivityDrawer = () => setIsActivityDrawerOpen(true);
  const handleCloseActivityDrawer = () => setIsActivityDrawerOpen(false);
  const activityEndpoint = ENDPOINT_TO_ENTITY_TYPE_MAP[table];

  // TODO: Adjust the selected items format when the backend team adds support for multiple activity creation
  const formattedSelectedItems = selectedItems?.map(item => {
    return {
      entityId: item.id,
      entityTypeId: getEntityTypePerItem({ table, item })
    };
  });

  return {
    activityEndpoint,
    canCreateMultipleActivities,
    formattedSelectedItems,
    handleCloseActivityDrawer,
    handleOpenActivityDrawer,
    isActivityDrawerOpen
  };
};
